export const uri = "/api/vt";

export const fetchConfig = (myBody = {}) => {
    let httpHeaders = new Headers({});
    httpHeaders.append("Content-Type", "application/json");
//  const timeZoneOffset = (new Date().getTimezoneOffset() / 60) * -1;
//  myHeaders.append("user-timezone-offset", timeZoneOffset);

    return {
        method: "POST",
        headers: httpHeaders,
        //mode: 'cors',
        //cache: "default",
        cache: "no-store",
        body: JSON.stringify(myBody)
    };
};

